var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStoreNoConnection = function SvgStoreNoConnection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72.000000pt",
    height: "56.000000pt",
    viewBox: "0 0 72.000000 56.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,56.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361 296 c-242 -242 -278 -286 -238 -286 7 0 53 40 102 90 87 87 91 90 135 90 29 0 60 -9 89 -25 49 -29 71 -32 71 -10 0 21 -70 64 -119 73 l-42 7 44 43 44 44 44 -23 c24 -12 58 -33 76 -46 32 -24 53 -24 53 1 0 15 -75 71 -116 86 l-27 11 38 39 39 39 35 -21 c20 -12 51 -34 69 -50 35 -30 47 -34 57 -17 9 13 -19 44 -75 82 -25 17 -47 32 -49 34 -3 2 10 19 29 37 20 22 30 41 27 50 -4 9 -10 16 -14 16 -5 0 -127 -119 -272 -264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 492 c-108 -29 -249 -126 -221 -154 8 -8 16 -8 30 3 151 109 188 123 339 124 130 0 168 16 83 34 -71 15 -154 13 -231 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 352 c-60 -21 -145 -78 -145 -97 0 -28 20 -25 67 9 47 33 127 66 162 66 10 0 26 9 36 20 18 20 17 20 -26 20 -24 -1 -66 -8 -94 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 76 c-28 -35 11 -93 48 -70 35 22 22 84 -18 84 -10 0 -23 -7 -30 -14z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStoreNoConnection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/store-no-connection.b4505a00.svg";
export { ForwardRef as ReactComponent };